import React, { useState } from 'react'
import { css } from 'glamor';
import Collapsible from 'react-collapsible';
import Select, { InputActionMeta, OptionsType, OptionTypeBase } from 'react-select';
import { DateRange } from 'react-date-range';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, format } from 'date-fns';
import * as styles from './SideFilter.style';
import expandIcon from '../../assets/icons/expand-small_darkblue.svg';
import collapseIcon from '../../assets/icons/collapse-small_darkblue.svg';
import searchIcon from '../../assets/icons/search_darkblue.svg';
import CloseIcon from '../../assets/icons/close-small_darkblue.svg';
import * as filterArticles from '../../configs/articleconfig';
import * as navData from '../../configs/navigation';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { enUS, fr } from 'date-fns/locale';
import { useEffect } from 'react';
import { default as ReactSelect, components } from "react-select";


const CommissionedSearchSideFilters = (props) => {
    const [collapsibleHeight, setCollapsibleHeight] = useState('auto');
    const [collapsibleHeightTag, setCollapsibleHeightTag] = useState('auto');
    const [viewAllLessText, setViewAllLessText] = useState('View all');
    const [hideShowAllCat, setHideShowAllCat] = useState('none');
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [errorDatepickerText, setErrorDatepickerText] = useState(null);
    const [fromErrorDatepicker, setFromErrorDatepicker] = useState(false);
    const [toErrorDatepicker, setToErrorDatepicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const filteredCategories = props?.categoryData?.categories?.filter(category =>
        !["Podcasts", "Link Only", "Forecasts", "Presentations"].includes(category.title)
    ).sort((a, b) => b.title.localeCompare(a.title));
    const firstFiveCat = props?.urlParams == "commr" ? navData?.companyListForSearchEnhancements.slice(0, 5) : (filteredCategories?.length >= 8) ? filteredCategories?.slice(0, 4) : filteredCategories;
    const viewMoreCat = props?.urlParams == "commr" ? navData?.companyListForSearchEnhancements.slice(5) : filteredCategories?.slice(4);
    const expandCollapseAllItem = JSON.parse(sessionStorage.getItem('expandCollapseAll'));
    const [expandCollapseAll, setExpandCollapseAll] = useState({
        "publicationDate": expandCollapseAllItem ? expandCollapseAllItem?.publicationDate : true,
        "type": expandCollapseAllItem ? expandCollapseAllItem?.type : true,
        "language": expandCollapseAllItem ? expandCollapseAllItem?.language : true,
        "analyst": expandCollapseAllItem ? expandCollapseAllItem?.analyst : true,
        "category": expandCollapseAllItem ? expandCollapseAllItem?.category : true,
        "tags": expandCollapseAllItem ? expandCollapseAllItem?.tags : true,
    });

    const periodOptions = [
        { value: 'Last 24 hours', label: 'Last 24 hours' },
        { value: 'Last 7 days', label: 'Last 7 days' },
        { value: 'Last 30 days', label: 'Last 30 days' },
        { value: 'Last year', label: 'Last year' },
        { value: 'Date range', label: 'Date range' },
    ]

    const typesOptions = [
        { value: 'Article', label: 'Article', disabled: true },
        { value: 'Forecast', label: 'Forecast', disabled: true },
        { value: 'Podcast', label: 'Podcast', disabled: true },
        { value: 'Video', label: 'Video', disabled: true },
        { value: 'Presentation', label: 'Presentation', disabled: true },
    ]

    const langOptions = [
        { value: 'DK', label: 'Dansk' },
        { value: 'EN', label: 'English' },
        { value: 'NO', label: 'Norsk' },
        { value: 'FI', label: 'Suomi' },
        { value: 'SE', label: 'Svenska' },
    ]

    const isValidDate = (date) => date !== null && date !== undefined && date !== '';
    // const analystsOptions = [/*{
    //     label: 'Following',
    //     options: [
    //         { value: 'Astrid Jorgensen', label: 'Astrid Jorgensen' },
    //         { value: 'Erik Virtanen', label: 'Erik Virtanen' },
    //         { value: 'Freja Lindberg', label: 'Freja Lindberg' },
    //     ]
    // },
    // {
    //     label: 'Other Analysts',
    //     options: [*/
    //     /*]
    // }*/
    // ]

    useEffect(() => {
        if (isValidDate(fromDate) && isValidDate(toDate)) {
            props?.setDateFilter([{
                "startDate": fromDate,
                "endDate": toDate,
                "key": "selection"
            }]);
            props.setFilterItems((prev) => ({ ...prev, "period": `${format(fromDate, 'MMM dd, yyyy')} - ${format(toDate, 'MMM dd, yyyy')}` }));
            props.setFilterItems((prev) => ({ ...prev, "publicationDate": { "fromDate": format(fromDate, 'yyyy-MM-dd'), 'toDate': format(toDate, 'yyyy-MM-dd') } }));
        }
    }, [fromDate, toDate])

    const handleDateInputChange = (e) => {
        const inputValue = event.target.value;
        const datePattern = /^\d{2}\/\d{2}\/\d{4}$/; // Pattern for dd/MM/yyyy format

        if (!datePattern.test(inputValue)) {
            setErrorDatepickerText('Please enter a date in the format dd/MM/yyyy');
        } else {
            setErrorDatepickerText('');
        }
    };

    const handleOntypeDatepicker = (e) => {
        let inputValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters

        // Format the input value with slashes
        if (inputValue.length > 2) {
            inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
        }
        if (inputValue.length > 5) {
            inputValue = inputValue.slice(0, 5) + '/' + inputValue.slice(5, 9);
        }

        e.target.value = inputValue; // Update the input value
    }

    const handleFromDateChange = (date) => {
        if (date) {
            setFromDate(date);
            if (toDate && date > toDate) {
                setToDate(null);
                setFromErrorDatepicker(true)
            } else {
                setFromErrorDatepicker(false)
            }
        } else {
            setFromDate(null);
            props?.setDateFilter((prev) => ([{ ...prev[0], "startDate": null }]));
        }
    };


    const handleToDateChange = (date) => {
        if (date) {
            setToDate(date);
            if (fromDate && date < fromDate) {
                setFromDate(null);
                setToErrorDatepicker(true)
            } else {
                setToErrorDatepicker(false)
            }
        } else {
            setToDate(null);
            props?.setDateFilter((prev) => ([{ ...prev[0], "endDate": null }]));
        }
    };

    const handleAnalystDropdownOpen = () => {
        setCollapsibleHeight('320px');
        // extendDropdownAnalystHeight();
    };

    const handleAnalystDropdownClose = () => {
        setCollapsibleHeight('auto');
    };

    const handleDropdownOpenTag = () => {
        setCollapsibleHeightTag('250px');
        // extendDropdownTagsHeight();
    };

    /*const extendDropdownTagsHeight = () => {
        if (props?.tagsSelectedVal?.optionTagsSelected?.length >= 4) {
            setCollapsibleHeightTag('500px')
            if (props?.tagsSelectedVal?.optionTagsSelected?.length >= 13) {
                setCollapsibleHeightTag('800px')
                if (props?.tagsSelectedVal?.optionTagsSelected?.length >= 18) {
                    setCollapsibleHeightTag('1000px')
                }
            }
        } else {
            setCollapsibleHeightTag('250px')
        }
    }*/

    /*const extendDropdownAnalystHeight = () => {
        if (props?.analystSelectedVal?.optionAnalystSelected?.length >= 3) {
            setCollapsibleHeight('500px')
            if (props?.analystSelectedVal?.optionAnalystSelected?.length >= 10) {
                setCollapsibleHeight('800px')
                if (props?.analystSelectedVal?.optionAnalystSelected?.length >= 18) {
                    setCollapsibleHeight('1000px')
                }
            }
        } else {
            setCollapsibleHeight('250px')
        }
    }*/

    const handleDropdownCloseTag = () => {
        setCollapsibleHeightTag('auto');
    };

    const retTime = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>Publication date
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retType = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>Type
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retLanguage = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>Language
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retAnalyst = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>Analyst
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retCategory = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>{props?.urlParams == "commr" ? 'Company' : 'Category'}
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retTags = () => {
        return (
            <div {...css(styles.collapseMaintitle)}>
                <p style={{ fontSize: '16px', fontWeight: '600', paddingLeft: '5px' }}>Tag
                    <p className='float-right'>
                        <div className="col-md-1 col-lg-1 col-sm-1 col-1">
                            <img className="expandIcon" alt="Expand Section" src={expandIcon} width={16} height={16} />
                            <img className="collapseIcon" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                        </div>
                    </p>
                </p>
            </div >
        )
    }
    const retAllDateRange = () => {
        return (
            <div>
                <p className="d-flex align-items-center" {...css(styles.timeType)} style={{ marginRight: '18px' }}>
                    <u>Date Range</u>
                    <img className="expandIcon ml-2" alt="Expand Section" src={expandIcon} width={16} height={16} />
                    <img className="collapseIcon ml-2" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                </p>
            </div>

        )
    }
    const retAllCategory = () => {
        return (
            <div>
                <p className="d-flex align-items-center" {...css(styles.timeType)} style={{ marginRight: '18px' }}>
                    <u>{viewAllLessText}</u>
                    <img className="expandIcon ml-2" alt="Expand Section" src={expandIcon} width={16} height={16} />
                    <img className="collapseIcon ml-2" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                </p>
            </div>

        )
    }

    const handleFilterByPeriod = (e, types) => {
        props?.setPeriodSelectedVal(e?.target?.value)
        if (e?.target?.labels[0]?.innerText == "Date range") {
            props?.setShowDatePicker(true);
        } else {
            props?.setDateFilter([{
                "startDate": null,
                "endDate": null,
                "key": "selection"
            }]);
            props.setFilterItems((prev) => ({ ...prev, "period": e?.target?.labels[0]?.innerText }));
            props?.setShowDatePicker(false)
            setFromDate(null)
            setToDate(null)
            if (e?.target?.labels[0]?.innerText == "Last 24 hours") {
                props.setPeriodSelectedDates({ "fromDate": format(addDays(new Date(), -1), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') })
                props.setFilterItems((prev) => ({ ...prev, "publicationDate": { "fromDate": format(addDays(new Date(), -1), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') } }));
            } else if (e?.target?.labels[0]?.innerText == "Last 7 days") {
                props.setPeriodSelectedDates({ "fromDate": format(addDays(new Date(), -7), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') })
                props.setFilterItems((prev) => ({ ...prev, "publicationDate": { "fromDate": format(addDays(new Date(), -7), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') } }));
            } else if (e?.target?.labels[0]?.innerText == "Last 30 days") {
                props.setPeriodSelectedDates({ "fromDate": format(addDays(new Date(), -30), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') })
                props.setFilterItems((prev) => ({ ...prev, "publicationDate": { "fromDate": format(addDays(new Date(), -30), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') } }));
            } else if (e?.target?.labels[0]?.innerText == "Last year") {
                props.setPeriodSelectedDates({ "fromDate": format(addDays(new Date(), -365), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') })
                props.setFilterItems((prev) => ({ ...prev, "publicationDate": { "fromDate": format(addDays(new Date(), -365), 'yyyy-MM-dd'), 'toDate': format(new Date(), 'yyyy-MM-dd') } }));
            }
        }
    }

    const handleFilterByTypes = (e) => {
        const { value, checked } = e.target;
        let typesChecked = Array.isArray(props.typesSelectedVal) ? [...props.typesSelectedVal] : [];
        if (checked) {
            props.setFilterItems(prev => {
                const updatedTypes = prev.types ? [...prev.types, value] : [value];
                return {
                    ...prev,
                    types: updatedTypes
                };
            });
            typesChecked.push(value);
        } else {
            props.setFilterItems(prev => {
                const updatedTypes = prev.types.filter(item => item !== value);
                return {
                    ...prev,
                    types: updatedTypes
                };
            });
            typesChecked = typesChecked.filter(item => item !== value);
        }
        props.setTypesSelectedVal(typesChecked);
    }

    const handleFilterByLanguages = (e) => {
        const { value, checked } = e.target;
        let langChecked = Array.isArray(props.languagesSelectedVal) ? [...props.languagesSelectedVal] : [];
        if (checked) {
            props.setFilterItems(prev => {
                const updatedTypes = prev.languages ? [...prev.languages, value] : [value];
                return {
                    ...prev,
                    languages: updatedTypes
                };
            });
            langChecked.push(value);
        } else {
            props.setFilterItems(prev => {
                const updatedTypes = prev.languages.filter(item => item !== value);
                return {
                    ...prev,
                    languages: updatedTypes
                };
            });
            langChecked = langChecked.filter(item => item !== value);
        }
        props.setLanguagesSelectedVal(langChecked);
    }

    const handleAnalystsDropdown = (e, inputActionMeta) => {
        let analysts = [];
        if (inputActionMeta.action === "select-option") {
            analysts = e
        } else if (inputActionMeta.action === "remove-value") {
            analysts = props?.analystSelectedVal?.optionAnalystSelected?.filter(analyst => analyst?.fullName !== inputActionMeta?.removedValue?.fullName);
        } else if (inputActionMeta.action === "deselect-option") {
            analysts = props?.analystSelectedVal?.optionAnalystSelected?.filter(analyst => analyst?.fullName !== inputActionMeta?.option?.fullName);
        } else if (inputActionMeta.action === "clear") {
            analysts = props?.analystSelectedVal?.optionAnalystSelected?.filter(analyst => !inputActionMeta?.removedValues.some(objItem => objItem.fullName === analyst.fullName));
        }
        props.setAnalystSelectedVal({
            optionAnalystSelected: analysts
        })
        props.setFilterItems(prev => ({ ...prev, "analysts_original": analysts }));
        // extendDropdownAnalystHeight();
    }


    const handleFilterByCategory = (e) => {
        const { value, checked } = e.target;
        // let categoryOrCompanyChecked = props?.urlParams == "commr" ? (Array.isArray(props.companyListSelectedVal) ? [props.companyListSelectedVal] : []) : (Array.isArray(props.categoriesSelectedVal) ? [...props.categoriesSelectedVal] : []);
        props.setFilterItems(prev => {
            return {
                ...prev,
                companyList: value,
                "uncheckedAll": false
            };
        });
        props.setCompanyListSelectedVal(value);
        // categoryOrCompanyChecked = categoryOrCompanyChecked.filter(item => item !== value);
        // if (checked) {
        //     if (props?.urlParams == "commr") {
        //         if (props?.showFilterItems?.uncheckedAll == true) {
        //             props.setFilterItems(prev => {
        //                 const updatedTypes = [value];
        //                 return {
        //                     companyList: updatedTypes,
        //                     "uncheckedAll": false
        //                 };
        //             });
        //             categoryOrCompanyChecked.push(value);
        //         } else {
        //             props.setFilterItems(prev => {
        //                 const updatedTypes = prev.companyList ? [...prev.companyList, value] : [value];
        //                 return {
        //                     ...prev,
        //                     companyList: updatedTypes,
        //                     "uncheckedAll": false
        //                 };
        //             });
        //             categoryOrCompanyChecked.push(value);
        //         }
        //     } else {
        //         props.setFilterItems(prev => {
        //             const updatedTypes = prev.categories ? [...prev.categories, value] : [value];
        //             return {
        //                 ...prev,
        //                 categories: updatedTypes,
        //             };
        //         });
        //         categoryOrCompanyChecked.push(value);
        //     }
        // } else {
        //     if (props?.urlParams == "commr") {
        //         props.setFilterItems(prev => {
        //             const updatedTypes = prev.companyList.filter(item => item !== value);
        //             return {
        //                 ...prev,
        //                 companyList: value,
        //                 "uncheckedAll": false
        //             };
        //         });
        //         categoryOrCompanyChecked = categoryOrCompanyChecked.filter(item => item !== value);
        //     } else {
        //         props.setFilterItems(prev => {
        //             const updatedTypes = prev.categories.filter(item => item !== value);
        //             return {
        //                 ...prev,
        //                 categories: updatedTypes,
        //                 "uncheckedAll": false
        //             };
        //         });
        //         categoryOrCompanyChecked = categoryOrCompanyChecked.filter(item => item !== value);
        //     }
        // }
        // // props?.urlParams == "commr" ? props.setCompanyListSelectedVal(categoryOrCompanyChecked) : props.setCategoriesSelectedVal(categoryOrCompanyChecked);
        // if (props?.urlParams == "commr") {
        //     if (categoryOrCompanyChecked?.length == 0) {
        //         // props.setCompanyListSelectedVal(Array.from(
        //         //     new Set(navData?.companyList?.map(item => item?.text))
        //         // ));
        //         props?.setUncheckedAll(true)
        //         props?.setFilterItems((prev) => ({ ...prev, "companyList": Array.from(new Set(navData?.companyList?.map(item => item?.text))), "uncheckedAll": true }));
        //     }
        //     props.setCompanyListSelectedVal(categoryOrCompanyChecked)
        // } else {
        //     props.setCategoriesSelectedVal(categoryOrCompanyChecked)
        // }
    }

    const analystComponentOptions = (props) => {
        return (
            <div>
                <components.Option {...props} className="option-container">
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label title={props.value}>{props.label}</label>
                </components.Option>
            </div>
        );
    };

    const Placeholder = (props) => {
        return (
            <components.Placeholder {...props}>
                <img
                    src={searchIcon}
                    alt="Search Icon"
                    style={{ width: '16px', marginRight: '8px', verticalAlign: 'middle' }}
                />
                {props.children}
            </components.Placeholder>
        );
    };

    const CustomDropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={expandIcon} alt="Dropdown" style={{ width: '20px', height: '20px' }} />
            </components.DropdownIndicator>
        );
    };

    const CustomClearIndicator = (props) => {
        return (
            <components.ClearIndicator {...props}>
                <img src={CloseIcon} alt="Clear" style={{ width: '20px', height: '20px' }} />
            </components.ClearIndicator>
        );
    };

    const CustomMultiValueRemove = (props) => {
        return (
            <components.MultiValueRemove {...props}>
                <img src={CloseIcon} alt="Remove" style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
            </components.MultiValueRemove>
        );
    };

    const handleExpandCollapseAll = (params, status) => {
        if (params == "publicationDate") {
            setExpandCollapseAll(prev => ({ ...prev, "publicationDate": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "publicationDate": status == "open" ? true : false }));
        } else if (params == "type") {
            setExpandCollapseAll(prev => ({ ...prev, "type": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "type": status == "open" ? true : false }));
        } else if (params == "language") {
            setExpandCollapseAll(prev => ({ ...prev, "language": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "language": status == "open" ? true : false }));
        } else if (params == "analyst") {
            setExpandCollapseAll(prev => ({ ...prev, "analyst": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "analyst": status == "open" ? true : false }));
        } else if (params == "category") {
            setExpandCollapseAll(prev => ({ ...prev, "category": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "category": status == "open" ? true : false }));
        } else if (params == "tags") {
            setExpandCollapseAll(prev => ({ ...prev, "tags": status == "open" ? true : false }));
            sessionStorage.setItem("expandCollapseAll", JSON.stringify({ ...expandCollapseAll, "tags": status == "open" ? true : false }));
        }
    }

    return (
        <div className='sidebarFilter'>
            <Collapsible key={"1"} trigger={retTime()} transitionTime={200} open={expandCollapseAllItem ? expandCollapseAllItem?.publicationDate : expandCollapseAll?.publicationDate} onOpening={() => handleExpandCollapseAll("publicationDate", "open")} onClosing={() => handleExpandCollapseAll("publicationDate", "close")}>
                <div style={{ marginTop: '10px' }}>
                    {
                        periodOptions?.map((resType, idx) => {
                            return (
                                <div className="form-check" key={idx} {...css(styles.PeriodType)}>
                                    <label className="form-check-label handCursor" htmlFor={`tim_${idx}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '30px' }}>
                                        <input type="radio" className="form-check-input handCursor" id={`tim_${idx}`} style={{ marginTop: '0px', marginRight: '10px' }} name="optradio" value={resType.value} onChange={(e) => handleFilterByPeriod(e, 'str')} checked={resType.value === props?.periodSelectedVal} />
                                        {resType?.label}
                                    </label>
                                </div>
                            )
                        })
                    }
                    {
                        (props?.showDatePicker) &&
                        <div {...css(styles.timeType)}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="fromDate" style={{ marginBottom: '2px', fontSize: '14px' }}>From</label>
                                    <DatePicker
                                        selected={(fromDate) ? fromDate : props?.dateFilter[0]?.startDate}
                                        onChange={handleFromDateChange}
                                        endDate={toDate}
                                        minDate={new Date('2017-11-29')}
                                        dateFormat="dd/MM/yyyy"
                                        maxDate={new Date()}
                                        className={`form-control no-italic-placeholder`}
                                        id="fromDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        autoComplete='off'
                                        showPopperArrow={false}
                                        fixedHeight
                                        onChangeRaw={handleDateInputChange}
                                        onKeyDown={handleOntypeDatepicker}
                                        placeholderText='DD/MM/YYYY'
                                        isClearable={(fromDate || props?.dateFilter[0]?.startDate) ? true : false}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="toDate" style={{ marginBottom: '2px', fontSize: '14px' }}>To</label>
                                    <DatePicker
                                        selected={toDate ? toDate : props?.dateFilter[0]?.endDate}
                                        onChange={handleToDateChange}
                                        startDate={fromDate}
                                        minDate={fromDate}
                                        maxDate={new Date()}
                                        dateFormat="dd/MM/yyyy"
                                        className={`form-control no-italic-placeholder`}
                                        id="toDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        autoComplete='off'
                                        showPopperArrow={false}
                                        fixedHeight
                                        onChangeRaw={handleDateInputChange}
                                        onKeyDown={handleOntypeDatepicker}
                                        placeholderText='DD/MM/YYYY'
                                        isClearable={(toDate || props?.dateFilter[0]?.endDate) ? true : false}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Collapsible>
            {/* <hr style={{ border: 'none', borderTop: '1px solid #DFEEF4' }} {...css(styles.customHrTag)}></hr>
            <Collapsible key={"5"} trigger={retCategory()} transitionTime={200} open={expandCollapseAllItem ? expandCollapseAllItem?.category : expandCollapseAll?.category} onOpening={() => handleExpandCollapseAll("category", "open")} onClosing={() => handleExpandCollapseAll("category", "close")}>
                <div style={{ marginTop: '10px' }}>
                    {
                        firstFiveCat?.map((resCat, idx) => {
                            const words = resCat?.title.split(' ');
                            if (words.length > 1) {
                                words[1] = words[1].toLowerCase();
                            }
                            const transformedText = words.join(' ');
                            return (
                                <div {...css(styles.timeType)} key={idx}>
                                    <div className="form-check-inline" style={{ display: 'flex', alignItems: 'center' }}>
                                        <label className="form-check-label handCursor" htmlFor={`cat_${idx}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '0px' }}>
                                            <input type="radio" className="mr-2 handCursor" id={`cat_${idx}`} name="category" value={resCat?.title} onChange={(e) => handleFilterByCategory(e)} checked={props?.companyListSelectedVal == resCat.title} />
                                            {transformedText}
                                        </label>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {
                        (props?.urlParams == "commr" || filteredCategories?.length >= 8) &&
                        <div>
                            {
                                hideShowAllCat == "none" &&
                                <p className="d-flex align-items-center handCursor" {...css(styles.timeType)} style={{ marginRight: '18px' }} onClick={() => setHideShowAllCat("block")}>
                                    <u>{viewAllLessText}</u><img className="expandIcon ml-2" alt="Expand Section" src={expandIcon} width={16} height={16} />
                                </p>
                            }
                            <div style={{ display: hideShowAllCat }}>
                                {
                                    viewMoreCat?.map((resViewMoreCat, idxc) => {
                                        console.log(resViewMoreCat?.title == props?.companyListSelectedVal)
                                        return (
                                            <div {...css(styles.timeType)} key={idxc}>
                                                <div className="form-check-inline" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <label className="form-check-label handCursor" htmlFor={`cat__${idxc}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '0px' }}>
                                                        <input type="radio" className="mr-2 handCursor" id={`cat__${idxc}`} name="category" value={resViewMoreCat?.title} onChange={(e) => handleFilterByCategory(e)} checked={props?.companyListSelectedVal == resViewMoreCat.title} />
                                                        {resViewMoreCat?.title}
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                hideShowAllCat == "block" &&
                                <p className="d-flex align-items-center handCursor" {...css(styles.timeType)} style={{ marginRight: '18px' }} onClick={() => setHideShowAllCat("none")}>
                                    <u>{"View less"}</u><img className="collapseIcon ml-2" alt="Collapse Section" src={collapseIcon} width={16} height={16} />
                                </p>
                            }
                        </div>
                    }
                </div>
            </Collapsible> */}
            <hr style={{ border: 'none', borderTop: '1px solid #DFEEF4' }} {...css(styles.customHrTag)}></hr>
            <Collapsible key={"4"} trigger={retAnalyst()} transitionTime={200} open={expandCollapseAllItem ? expandCollapseAllItem?.analyst : expandCollapseAll?.analyst} onOpening={() => handleExpandCollapseAll("analyst", "open")} onClosing={() => handleExpandCollapseAll("analyst", "close")} overflowWhenOpen={'unset'}>
                <div /*style={{ height: collapsibleHeight }}*/ style={{ marginTop: '10px' }}>
                    <div {...css(styles.timeType)} >
                        <ReactSelect
                            options={props?.AnalystsData}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            className='analystSelect'
                            components={{
                                Option: analystComponentOptions,
                                DropdownIndicator: CustomDropdownIndicator,
                                ClearIndicator: CustomClearIndicator,
                                MultiValueRemove: CustomMultiValueRemove,
                                // Placeholder: Placeholder
                            }}
                            // menuIsOpen={true}
                            // getOptionLabel={(option) => option?.fullName}
                            getOptionLabel={(option) => {
                                const fullName = option?.fullName || '';
                                return fullName.length > 29 ? `${fullName.substring(0, 29)}...` : fullName;
                            }}
                            getOptionValue={(option) => option?.fullName}
                            onChange={handleAnalystsDropdown}
                            onKeyDown={(e) => {
                                if (e.key === 'Backspace' && props?.analystSelectedVal?.optionAnalystSelected.length > 0) {
                                    if (props?.analystSelectedVal?.optionAnalystSelected.length > 0 && e.target.value === '') {
                                        e.preventDefault();
                                    }
                                }
                            }}
                            value={props?.analystSelectedVal?.optionAnalystSelected}
                            // onMenuOpen={handleAnalystDropdownOpen}
                            // onMenuClose={handleAnalystDropdownClose}
                            aria-label='Analyst selection dropdown'
                            ariaLiveMessages={{
                                onFocus: () => 'Press down arrow to access Analyst filter options',
                                onChange: ({ label }) => `${label} has been selected.`,
                                onMenuOpen: () => 'Analyst options menu opened',
                                onMenuClose: () => 'Analyst options menu closed'
                            }}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: '#99B7C9',
                                    width: '92%',
                                }),
                                option: (base, { isSelected, isFocused }) => ({
                                    ...base,
                                    backgroundColor: isSelected ? '#DFEEF4' : isFocused ? '#DFEEF4' : base.backgroundColor,
                                    color: isSelected ? '#003755' : base.color,
                                    ':active': {
                                        ...base[':active'],
                                        backgroundColor: isSelected ? '#DFEEF4' : base[':active'].backgroundColor,
                                        color: isSelected ? '#003755' : base[':active'].color,
                                    },
                                    ':hover': {
                                        ...base[':hover'],
                                        backgroundColor: '#DFEEF4',
                                    },
                                }),
                                /*valueContainer: (base) => ({
                                    ...base,
                                    maxHeight: '100px',
                                    overflowY: 'auto',
                                    paddingRight: '10px',
                                }),*/
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    border: '2px solid #007BC7',
                                    padding: '0px 0px',
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#003755',
                                    padding: '0 0px',
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#003755',
                                    cursor: 'pointer',
                                    ':hover': {
                                        backgroundColor: 'none',
                                        color: '#003755',
                                    },
                                }),
                                clearIndicator: (base) => ({
                                    ...base,
                                    color: '#003755',
                                    cursor: 'pointer',
                                    ':hover': {
                                        color: '#003755',
                                    },
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#003755',
                                    ':hover': {
                                        color: '#003755',
                                    },
                                }),
                                indicatorSeparator: (base) => ({
                                    ...base,
                                    backgroundColor: '#99B7C9',
                                }),
                            }}
                            style={{ transition: '200ms linear ease-in-out' }}
                            maxMenuHeight={500}
                            placeholder={'Search analyst'}
                        />
                    </div>
                </div>
            </Collapsible >
            <hr style={{ border: 'none', borderTop: '1px solid #DFEEF4' }} {...css(styles.customHrTag)}></hr>
            <Collapsible key={"3"} trigger={retLanguage()} transitionTime={200} open={expandCollapseAllItem ? expandCollapseAllItem?.language : expandCollapseAll?.language} onOpening={() => handleExpandCollapseAll("language", "open")} onClosing={() => handleExpandCollapseAll("language", "close")}>
                <div style={{ marginTop: '10px' }}>
                    {
                        langOptions?.map((resType, idx) => {
                            return (
                                <div {...css(styles.timeType)} key={idx}>
                                    <div className="form-check-inline" style={{ display: 'flex', alignItems: 'center' }}>
                                        <label className="form-check-label handCursor" htmlFor={`lang_${idx}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '0px' }}>
                                            <input type="checkbox" className="mr-2 handCursor" name="Languages" value={resType.value} id={`lang_${idx}`} onChange={(e) => handleFilterByLanguages(e)} checked={props?.languagesSelectedVal?.includes(resType.value)} />
                                            {resType?.label}
                                        </label>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </Collapsible>
            <hr style={{ border: 'none', borderTop: '1px solid #DFEEF4' }} {...css(styles.customHrTag)}></hr>
            <Collapsible key={"2"} trigger={retType()} transitionTime={200} open={expandCollapseAllItem ? expandCollapseAllItem?.type : expandCollapseAll?.type} onOpening={() => handleExpandCollapseAll("type", "open")} onClosing={() => handleExpandCollapseAll("type", "close")}>
                <div style={{ marginTop: '10px' }}>
                    {
                        typesOptions?.map((resType, idx) => {
                            return (
                                <div {...css(styles.timeType)} key={idx}>
                                    <div className="form-check-inline" style={{ display: 'flex', alignItems: 'center' }}>
                                        <label className="form-check-label handCursor" htmlFor={`tpe_${idx}`} style={{ display: 'flex', alignItems: 'center', paddingLeft: '0px' }}>
                                            <input type="checkbox" className="mr-2 handCursor" name="Articles" value={resType.value} id={`tpe_${idx}`} onChange={(e) => handleFilterByTypes(e)} checked={resType.value == "Article" ? true : false/*props?.typesSelectedVal?.includes(resType.value)*/} disabled={resType?.disabled} />
                                            {resType?.disabled ? (
                                                <span style={{ opacity: '40%', cursor: 'not-allowed' }}>{resType?.label}</span>
                                            ) : (
                                                <span>{resType?.label}</span>
                                            )}
                                        </label>
                                    </div>
                                </div>

                            )
                        })
                    }
                </div>
            </Collapsible>
        </div >

    )
}

export default CommissionedSearchSideFilters